export enum CommonEntityState {
  Draft = 'draft',
  Active = 'active',
  Inactive = 'inactive',
  Deleted = 'deleted',
}
